export default __webpack_public_path__ + "static/media/DecentLogo.6cdf7d47.png";